"use strict";
Object.defineProperty(exports, "__esModule", { value: true });



//////////////////
// WEBPACK FOOTER
// ./~/@optimizely/js-sdk-event-processor/lib/eventDispatcher.js
// module id = 1287
// module chunks = 37